<template>
  <vs-popup
    ref="otpPopUp"
    class="otp-pop-up"
    :title="title"
    :active="isPopUpActive"
  >
    <div class="flex flex-col items-center gap-5">
      <slot name="pop-up-content" />

      <div
        ref="otpContainer"
        class="otp-container"
      >
        <vs-input
          v-for="(digit, index) of otpLength"
          :key="`${index}-${digit}`"
          v-model="otpCode[index]"
          :autofocus="index === 0"
          maxlength="1"
          type="number"
          class="otp-item"
          @keydown="handleKeyDown(index, $event)"
          @paste="handlePaste($event)"
        />
      </div>

      <slot name="resend-new-code" />

      <vs-button
        color="primary"
        class="h-12 w-full mt-12 text-base font-semibold"
        @click="onVerifyOtp()"
        :disabled="isVerifyButtonDisabled"
      >
        Verify Code
      </vs-button>
    </div>
  </vs-popup>
</template>

<script>

export default {
  name: 'OtpPopUp',
  props: {
    shown: {
      type: Boolean,
      default: () => true
    },
    title: {
      type: String,
      default: () => 'Verification Code'
    },
    default: {
      type: String,
      default: () => ''
    },
    otpLength: {
      type: Number,
      default: 6
    }
  },
  mounted() {
    // Prevent popup close on background click
    const next = this.$refs.otpPopUp.$children[0]
    next.$el.addEventListener('click', this.onClickCloseButton, false);

    if (this.default && this.default.length === this.otpLength) {
      [...Array(this.otpLength)].forEach((_, index) => {
        this.$set(this.otpCode, index, this.default.charAt(index))
      })
    } else {
      [...Array(this.otpLength)].forEach((_, index) => {
        this.$set(this.otpCode, index, '')
      })
    }
  },
  computed: {
    isVerifyButtonDisabled() {
      return this.otpCode.some((item) => !item)
    }
  },
  data() {
    return {
      otpCode: [],
      isPopUpActive: this.shown
    }
  },
  watch: {
    shown: {
      handler(val) {
        this.isPopUpActive = val
      }
    },
    isPopUpActive: {
      handler(val) {
        this.$emit('update:shown', val)
      }
    }
  },
  methods: {
    onClickCloseButton() {
      this.$emit('update:shown', false)
    },
    onOtpInput(index, value) {
      const digit = value.replace(/[^0-9]/g, '').slice(0, 1)
      this.$set(this.otpCode, index, digit)
    },
    handleKeyDown(index, event) {
      if (event.ctrlKey||event.metaKey) {
        return false;
      }

      if (event.key !== "Tab" &&
        event.key !== "ArrowRight" &&
        event.key !== "ArrowLeft"
      ) {
        event.preventDefault()
      }

      if (event.key === 'Backspace') {
        this.$set(this.otpCode, index, '')

        if (index !== 0) {
          this.$nextTick(() => {
            const nextComponent = this.$refs.otpContainer.children[index - 1]
            if (nextComponent) {
              const inputEl = nextComponent.querySelector('input')
              if (inputEl) {
                inputEl.focus()
                inputEl.classList.add('isFocus')
              }
            }
          })
        }
      }

      if ((new RegExp('^([0-9])$')).test(event.key)) {
        this.onOtpInput(index, event.key)

        if (index !== this.otpLength - 1) {
          this.$nextTick(() => {
            const nextComponent = this.$refs.otpContainer.children[index + 1]
            if (nextComponent) {
              const inputEl = nextComponent.querySelector('input')
              if (inputEl) {
                inputEl.focus()
                inputEl.classList.add('isFocus')
              }
            }
          })
        }
      }
    },
    handlePaste(event) {
      event.preventDefault()

      const pasted = (event.clipboardData || window.clipboardData).getData('text')
      const codes = pasted.trim().split('')
      codes.forEach((number, index) => {
        this.onOtpInput(index, number)
      })

      if (codes.length < this.otpLength) {
        this.$nextTick(() => {
          const nextComponent = this.$refs.otpContainer.children[codes.length]
          if (nextComponent) {
            const inputEl = nextComponent.querySelector('input')
            if (inputEl) {
              inputEl.focus()
              inputEl.classList.add('isFocus')
            }
          }
        })
      } else if (codes.length === this.otpLength) {
        this.$nextTick(() => {
          const nextComponent = this.$refs.otpContainer.children[codes.length - 1]
          if (nextComponent) {
            const inputEl = nextComponent.querySelector('input')
            if (inputEl) {
              inputEl.focus()
              inputEl.classList.add('isFocus')
            }
          }
        })
      }
    },
    onVerifyOtp() {
      const formattedOtp = this.otpCode.join('');
      this.$emit('update:otp-code-model', formattedOtp)
      this.$emit('update:is-verify-ready', Date.now())
    }
  }
}
</script>

<style lang="scss" scoped>

.otp-pop-up {
  &/deep/.vs-popup {
    @apply p-3 rounded-2xl;
    width: fit-content;

    .vs-popup--header {
      @apply bg-white;

      .vs-popup--title {
        @apply font-semibold;
      }

      .vs-popup--close {
        @apply transform-none shadow-none;
        color: #493493;
      }
    }

    .vs-popup--content {
      @apply flex flex-col items-center justify-center;
    }
  }
}

.otp-container {
  @apply flex flex-row items-center justify-center gap-5;

  /deep/.vs-input {

    .vs-con-input {
      @apply border-2 border-primary rounded-xl;

      .vs-input--input {
        @apply w-16 h-16 bg-white;
        @apply text-center text-3xl text-primary font-medium;

        -moz-appearance: textfield;
      }

      .vs-input--input::-webkit-outer-spin-button,
      .vs-input--input::-webkit-inner-spin-button{
        -webkit-appearance: none;
        margin: 0;
      }
    }

  }

  .otp-item {

  }
}

</style>